<template>
  <div>
    <div class="wap1">
      <div class="wap1-content">
        <h1 class="title">{{ ourAbility.titleOne }}</h1>
        <p>{{ ourAbility.contentOne }}</p>
        <p>{{ ourAbility.contentTwo }}</p>
      </div>
    </div>
    <div class="wap2">
      <div class="ability1">
        <div class="img_cover" :style="{backgroundImage: `url(${pictureList.length > 0 && pictureList[0] ? pictureList[0] : ''})`}"></div>
        <div class="bg_content">
          <div class="content_right">
            <div class="content_details">
              <h2 class="title">{{ ourAbility.list[0].title }}</h2>
              <p v-html="ourAbility.list[0].content"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="ability2">
        <div class="bg_content">
          <div class="content_left">
            <div class="content_details">
              <h2 class="title">{{ ourAbility.list[1].title }}</h2>
              <p v-html="ourAbility.list[1].content"></p>
            </div>
          </div>
        </div>
        <!-- 生成铸造能力 幻灯片未作 -->
        <div class="img_cover" :style="{ backgroundImage: `url(${pictureList.length > 0 && pictureList[1] ? pictureList[1] : ''})` }"></div>  
      </div>
      <div class="ability3">
        <!-- 加工焊接能力 幻灯片未作 -->
        <div class="img_cover" :style="{ backgroundImage: `url(${pictureList.length > 0 && pictureList[2] ? pictureList[2] : ''})` }"></div>
        <div class="bg_content">
          <div class="content_right">
            <div class="content_details">
              <h2 class="title">{{ ourAbility.list[2].title }}</h2>
              <p v-html="ourAbility.list[2].content"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="ability4">
        <div class="bg_content">
          <div class="content_left">
            <div class="content_details">
              <h2 class="title">{{ ourAbility.list[3].title }}</h2>
              <p v-html="ourAbility.list[3].content"></p>
            </div>
          </div>
        </div>
        <div class="img_cover" :style="{ backgroundImage: `url(${pictureList.length > 0 && pictureList[3] ? pictureList[3] : ''})` }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { getConfigDataApi } from "@/utils/http.js"

export default {
  name: 'Ability',

  data() {
    return {
      commonData: {},
      pictureList: []
    }
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    ourAbility() {
      return this.currentLang.config.aboutPage.ourAbility
    }
  },

  created() {
    this.fetchCommonData();
  },

  methods: {
    fetchCommonData() {
      getConfigDataApi().then(result => {
        if (result.code == 1) {
          this.commonData = result.data
          this.pictureList = result.data.capacity_pictures
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.wap1 {
  padding-top: 70px;
  padding-bottom: 70px;
  .wap1-content {
    width: 1000px;
    margin: 0 auto 0;
    text-align: center;
    .title {
      font-size: 30px;
      color: #333;
      font-weight: 500;
    }
    p {
      font-size: var(--text-size-bit-larger);
      color: #777;
      line-height: 1.8;
      margin-top: 40px;
      text-align: justify;
      text-align-last: center;
    }
  }
}
.wap2 {
  .ability1 {
    display: flex;
    height: 550px;
    
    .img_cover {
      // background: url(../../assets/images/about/i1001.jpg) no-repeat center 20%;
      background-repeat: no-repeat;
      background-position: center 20%;
      background-size: cover;
    }
  }
  .ability2 {
    display: flex;
    height: 550px;
    // 生成铸造能力 幻灯片未作
    .img_cover {
      // background: url(../../assets/images/about/ability2-4.jpg) no-repeat center;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
  }
  .ability3 {
    display: flex;
    height: 550px;
    // 加工焊接能力 幻灯片未作
    .img_cover {
      // background: url(../../assets/images/about/ability3-1.jpg) no-repeat center;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
  }
  .ability4 {
    display: flex;
    height: 550px;
    .img_cover {
      // background: url(../../assets/images/about/ability4.jpg) no-repeat center;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
  }

  .img_cover {
    width: 50%;
    min-width: 600px;
  }

  .bg_content {
    width: 50%;
    min-width: 600px;
    background: #f5f5f5;
    position: relative;
  }
  //文字内容在右侧时
  .content_right {
    left: 85px;
    width: 520px;
    height: 550px;
    display: table;
    position: absolute;
    .content_details {
      display: table-cell;
      vertical-align: middle;
    }
  }

  //文字内容在左侧时
  .content_left {
    right: 85px;
    width: 520px;
    height: 550px;
    display: table;
    position: absolute;
    .content_details {
      display: table-cell;
      vertical-align: middle;
    }
  }

  h2 {
    color: #003359;
    font-weight: 500;
    line-height: 28px;
    margin-bottom: 36px;
    font-size: 26px;
  }
  p {
    font-size: 16px;
    font-size: var(--text-size-normal);
    color: #777;
    line-height: 1.8;
    text-align: justify;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/about/ability.vue